import React from "react";

import { useLocation, Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({children}) => {
  const token = JSON.parse(localStorage.getItem("user"))?.access;

  // console.log('token', token)
  const location = useLocation();

  return token ? (
    // <Outlet />
    children
    ) : (
    <Navigate to="/client-login" state={{ from: location }} replace />
   );
};

export default ProtectedRoute;


